import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

// Internal Import
import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Testimonial.scss";

const Testimonial = () => {
  const [brands, setBrands] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  const test = testimonials[currentIndex];

  useEffect(() => {
    const query = '*[_type == "testimonials"]';
    const brandsQuery = '*[_type == "brands"]';

    client.fetch(query).then((data) => {
      setTestimonials(data);
    });

    client.fetch(brandsQuery).then((data) => {
      setBrands(data);
    });
  }, []);

  return (
    <>
      {testimonials.length && (
        <>
          <div className="app__testimonial-item app__flex dark:bg-darkthemealt">
            <img src={urlFor(test.imageUrl)} alt="testimonial" />
            <div className="app__testimonial-content">
              <p className="p-text dark:text-slate-400">{test.feedback}</p>

              <div>
                <h4 className="bold-text dark:text-slate-50">{test.name}</h4>
                <h5 className="p-text dark:text-[#A3B3BC]">{test.company}</h5>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex cursor-pointer">
            <div
              className="app__flex dark:bg-darkthemealt"
              onClick={() =>
                handleClick(
                  currentIndex === 0
                    ? testimonials.length - 1
                    : currentIndex - 1
                )
              }
            >
              <HiChevronLeft />
            </div>
            <div
              className="app__flex dark:bg-darkthemealt"
              onClick={() =>
                handleClick(
                  currentIndex === testimonials.length - 1
                    ? 0
                    : currentIndex + 1
                )
              }
            >
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      <div className="w-full mt-16 flex sm:flex-row flex-col items-center justify-center text-center">
        <div className="sm:flex-1 w-full h-[1px] dark:bg-[#2A2C30] bg-[#D8E5FF]"></div>
        <p className="xs:text-[16px] xs:leading-[22px] text-[14px] leading-[20px] font-normal flex-[1.5] dark:text-[#A3B3BC] text-[#5B6478] mx-4 sm:py-0 py-4">
          Trusted by several industry leaders
        </p>
        <div className="sm:flex-1 w-full h-[1px] dark:bg-[#2A2C30] bg-[#D8E5FF]"></div>
      </div>

      <Marquee gradient={false} speed={50}>
        <div className="app__testimonial-brands app__flex">
          {brands.map((brand) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              whileHover={{ scale: [1, 1.2] }}
              transition={{ duration: 0.5, type: "tween" }}
              key={brand._id}
            >
              <img src={urlFor(brand.imgUrl)} alt={brand.name} />
            </motion.div>
          ))}
        </div>
      </Marquee>
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, "app__testimonial"),
  "testimonial",
  "app__primarybg dark:bg-darktheme dark:transition-all"
);
